import { getGlobalJWebRegistry } from './global';
const globalJWebRegistry = getGlobalJWebRegistry();
const jWebReady = globalJWebRegistry.jWebReady;
const registerPlugin = globalJWebRegistry.registerPlugin;
export { jWebReady, registerPlugin };
export { WebPlugin } from './web-plugin';
export * from './core-plugin-definitions';
//# sourceMappingURL=index.js.map